import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import 'react-dates/initialize'
// import 'react-dates/lib/css/_datepicker.css'

import ModalFullScreen from '../../mini/ModalFullScreen'
import FlexAlignCenter from '../../styled/FlexAlignCenter'
import CloseModal from '../../styled/CloseModal'
import {
  SaveButton,
  HeaderBlock,
  ErrorMessage,
  ErrorButtonBlock,
  ModalQuestBlock,
  ErrorContainer,
  ErrorHeader,
  ErrorModalTop
} from './_Styled'
import { hideModal } from '../../../actions/_modal'

export class TargetDateSavingError extends Component {
  constructor (props) {
    super(props)

    this.state = {
      isClosing: false
    }

    this.closeTheModalBound = this.closeTheModal.bind(this)
  }

  async componentDidMount () {
    this.setState(() => ({
      isClosing: false
    }))
  }

  render () {
    return (
      <ModalFullScreen
        padding={'200px 0 0'}
        allowEscape
        closeCallback={this.closeTheModalBound}
        isClosing={this.state.isClosing}
        backgroundColor='rgba(36, 54, 70, 0.4)'
        allowCloseOnExternalClick
        bodyStyles={{width: 'fit-content'}}
      >
        <CloseModal
          size={21}
          onClick={this.closeTheModalBound}
          offWhiteIcon
        />
        <ErrorContainer
          onClick={e => {
            e.preventDefault()
            e.stopPropagation()
          }}
        >
          <React.Fragment>
            <ErrorModalTop style={{border: 'none'}}>
              <FlexAlignCenter
                style={{
                  position: 'relative',
                  width: '100%',
                  justifyContent: 'space-between'
                }}
              >
                <HeaderBlock style={{ margin: '0 auto' }}>
                  <ErrorHeader>Oops!</ErrorHeader>
                </HeaderBlock>
              </FlexAlignCenter>
            </ErrorModalTop>
            <ModalQuestBlock style={{ border: 'none', margin: '0 auto' }}>
              <ErrorMessage style={{ margin: '0 auto' }}>
                <p>An error occurred and the target dates were not saved. Please try again.</p>
              </ErrorMessage>
            </ModalQuestBlock>
            <ErrorButtonBlock>
              <SaveButton onClick={this.closeTheModalBound}>OK</SaveButton>
            </ErrorButtonBlock>
          </React.Fragment>
        </ErrorContainer>
      </ModalFullScreen>
    )
  }

  closeTheModal () {
    const { dispatch } = this.props

    this.setState({
      isClosing: true
    })

    setTimeout(() => {
      dispatch(hideModal())
    }, 500)
  }
}

TargetDateSavingError.propTypes = {
  dispatch: PropTypes.func.isRequired
}

export const mapStateToProps = state => ({
  orgId: state.organization.orgId,
  token: state.auth.token
})

export default connect(mapStateToProps)(TargetDateSavingError)
